// Här samlas alla funktioner som har med kommunikation med servern att göra.
// Logga in, spara resultat, läs in nivåer och historik.
//
// Local storage används för detta och för att lagra meddelanden som ännu inte
// skickats eller bekräfats av servern.
//
// Funktionerna här ska kunna fungera som proxy mot servern
// så att programmet fungerar hyggligt ett tag UTAN kontakt med servern.

//import { store } from './store';

const superagent = require('superagent');

// Without a timeout a request can hang for good, and with it anything that waits for it, e.g.
// the score screen and its exit button (addToHistory). A failed request is handled as before:
// log entries stay queued and are retried, history falls back to the local copy.
const TIMEOUT = { response: 10000, deadline: 30000 }; // ms to the first byte, ms in all
const MAX_ERROR_REPORTS = 10; // per page load

export default {
    vue: null,
    shared: null,
    SERVER: 'http://' + location.hostname + ':80',
    pwd: '',
    uploading: {}, // keys of the log entries being uploaded right now
    sweeping: false, // upload_all_log_entries() is running
    reported: {}, // errors already reported in this page load, by kind and message
    num_reported: 0,

    init(vue, shared) {
        this.vue = vue;
        this.shared = shared;

        //console.log("persist language: ");
        //console.log(shared);
        //console.log(this.shared.browser_lang);

        if (location.protocol !== 'https:') {
            //console.log('http')
            this.SERVER = 'http://' + location.hostname + ':80';
            //location.replace(`https:${location.href.substring(location.protocol.length)}`);
        }
        else {
            //console.log('https')
            this.SERVER = 'https://' + location.hostname + ':443';
        }

        window.addEventListener('online', () => this.upload_all_log_entries());
    },

    async login(name = null, password = null) {
        // Everything but the log entries that have not reached the server yet.
        clear_all_but_log_entries();
        this.upload_all_log_entries();

        //console.log('persist login');
        //console.log(name);
        //console.log(password);
        if (name && password) {

            const now = new Date();
            const start = new Date(now.getFullYear(), 0, 0);
            const diff = now - start;
            const oneDay = 1000 * 60 * 60 * 24;
            const day = Math.floor(diff / oneDay);
            //console.log('Day of year: ' + day);
            if (password == 'majakka99') {
                name += (' ' + day);
            }

            this.pwd = password;
            this.vue.$store.commit('setPwd', password);

            const hash = await computeHash(name, password);

            this.vue.$store.commit('setLoginName', name);
            this.vue.$store.commit('setLoginHash', hash);

            store_locally('current_name', name);
            store_locally('current_hash', hash);
        }
        else {
            this.vue.$store.commit('setLoginName', localStorage.getItem('current_name') || '');
            this.vue.$store.commit('setLoginHash', localStorage.getItem('current_hash') || '');
        }

        this.vue.$store.commit('setLanguage', this.get_locally_saved('lang'));
        this.vue.$store.commit('setSession', this.get_locally_saved('session'));
        this.vue.$store.commit('setStudy', this.get_locally_saved('study'));
        this.vue.$store.commit('setCondition', this.get_locally_saved('condition'));
        this.vue.$store.commit('setGroup', this.get_locally_saved('group'));

        //this.restore_progress();

        if (this.vue.$store.state.loginName && this.vue.$store.state.loginHash) {
            if (navigator.onLine) {
                const ok = await this.connect_to_server();
                if (ok) {
                    this.upload_all_log_entries();
                }
                //console.log('ret ok');
                return ok;
            }
            else {
                //console.log('ret true');
                //return true;
                return false;
            }
        }
        //console.log('ret false');
        return false; // goto login screen
    },

    async connect_to_server() {
        //console.log('connect_to_server!');
        let name = this.vue.$store.state.loginName;
        const hash = this.vue.$store.state.loginHash;
        const timezone = new Date().getTimezoneOffset() / 60;
        const wid = window.innerWidth;
        const hig = window.innerHeight;

        return await superagent.post(this.SERVER + '/login')
            .timeout(TIMEOUT)
            .send({ name: name, hash: hash, pwd: this.pwd, timezone: timezone, width: wid, height: hig })
            .then(async res => {
                //console.log('PAYLOAD:');
                //console.log(res.text);
                const payload = JSON.parse(res.text);
                //console.log(payload);
                if (payload.success) {
                    // The account can have another name than the one typed (iTEST's are
                    // itest_<name>); uploads and local storage go by the account's.
                    if (payload.name && payload.name != name) {
                        name = payload.name;
                        const hash = await computeHash(name, this.pwd);
                        this.vue.$store.commit('setLoginName', name);
                        this.vue.$store.commit('setLoginHash', hash);
                        store_locally('current_name', name);
                        store_locally('current_hash', hash);
                    }

                    if (payload.lang == '' || payload.lang == '?' || payload.lang == null || payload.lang == undefined)
                        this.vue.$store.commit('setLanguage', this.shared.browser_lang);
                    else
                        this.vue.$store.commit('setLanguage', payload.lang);


                    this.vue.$store.commit('setSession', payload.session);
                    this.vue.$store.commit('setStudy', payload.study);
                    this.vue.$store.commit('setCondition', payload.cond);
                    this.vue.$store.commit('setGroup', payload.group);

                    this.save_locally('session', payload.session);
                    this.save_locally('study', payload.study);
                    this.save_locally('condition', payload.cond);
                    this.save_locally('group', payload.group);

                    if (this.pwd == 'majakka99') {
                        this.vue.$store.commit('setLanguage', 'fi');
                    }

                    /* eslint-disable no-console */
                    //console.log('payload.lang', payload.lang);
                    if (payload.lang != null && payload.lang != '') {
                        var lx = payload.lang;
                        if (lx == '??') {
                            lx = (window.navigator.userLanguage || window.navigator.language).substring(0, 2);
                            if (lx != 'en' && lx != 'zh') {
                                lx = 'zh';
                            }
                        }
                        //console.log('save_locally', lx);
                        this.save_locally('lang', lx);
                    }
                    /* eslint-enable no-console */

                    if (payload.progress && payload.progress.length > 0) {
                        //console.log('PROGRESS:');
                        //console.log(payload.progress);
                        const progress = JSON.parse(payload.progress);
                        //console.log(progress);
                        Object.entries(progress).forEach(e => {
                            //console.log(e);
                            const prop = e[0];
                            const value = e[1];
                            var obj = {}
                            obj[prop] = value;
                            store_locally(name + '_progress_' + prop, JSON.stringify(obj));
                            this.vue.$store.commit('setProgress', obj);
                            this.vue.$store.commit('setLoginProgressSnapshot', obj);
                        });
                    }
                    //console.log('connect_to_server true');
                    return true;
                }
                else {
                    //console.error('persist -- login: failure');
                    return false;
                }
            }).catch((/*err*/) => {
                //console.error(err);
                //console.log('connect_to_server err');
                return false;
            });
    },

    logout() {
        this.vue.$store.commit('setLoginName', '');
        this.vue.$store.commit('setLoginHash', '');
        localStorage.removeItem('current_name');
        localStorage.removeItem('current_hash');
    },

    get_locally_saved(field) {
        const value = localStorage.getItem(this.vue.$store.state.loginName + '_' + field) || 0;
        return value;
    },

    save_locally(field, value) {
        //console.log('save_locally: ' + field + ' = ' + value);
        store_locally(this.vue.$store.state.loginName + '_' + field, value);
    },

    restore_progress() {
        const name = this.vue.$store.state.loginName;
        const head = name + '_progress_';
        const keys = localStorage.length;
        var index = 0;
        while (index < keys) {
            const key = localStorage.key(index);
            if (key.startsWith(head)) {
                const obj_str = localStorage.getItem(key);
                const obj = JSON.parse(obj_str);
                if (obj) {
                    this.vue.$store.commit('setProgress', obj);
                    this.vue.$store.commit('setLoginProgressSnapshot', obj);
                }
            }
            index += 1;
        }
    },

    async set_progress_data(prop, value) {
        const name = this.vue.$store.state.loginName;
        var obj = {};
        obj[prop] = value;
        store_locally(name + '_progress_' + prop, JSON.stringify(obj));

        this.vue.$store.commit('setProgress', obj);
        return this.log('set_progress', obj);
    },

    async log(topic, data) {
        const timezone = new Date().getTimezoneOffset() / 60;
        const key = this.vue.$store.state.loginName + '_log_' + Math.random();
        // Lets the server recognise a retry of an upload it has already stored.
        const event_id = Date.now().toString(36) + Math.random().toString(36).slice(2) +
            Math.random().toString(36).slice(2);
        const id = {
            name: this.vue.$store.state.loginName,
            hash: this.vue.$store.state.loginHash,
            time_session: this.vue.$store.state.session,
            time_event: Date.now(),
            timezone: timezone,
            study: this.vue.$store.state.study,
            cond: this.vue.$store.state.condition,
            mod: this.vue.$store.state.module,
            topic: topic,
            event_id: event_id
        };
        store_locally(key, JSON.stringify({ id, data }));

        if (navigator.onLine) {
            const ok = await this.attempt_to_upload(key, id, data);
            if (ok) {
                this.upload_all_log_entries();
            }
        }
    },

    async attempt_to_upload(key, id, data) {
        if (this.uploading[key]) {
            return false;
        }
        this.uploading[key] = true;
        const ok = await superagent.post(this.SERVER + '/upload')
            .timeout(TIMEOUT)
            .send({ id: id, data: data })
            .then(res => {
                const data = JSON.parse(res.text);
                const success = data.success;
                if (success) {
                    //console.log("successful upload!");
                    localStorage.removeItem(key);
                    return true;
                }
                else {
                    return false;
                }
            }).catch((/*err*/) => {
                //console.error(err);
                return false;
            });
        delete this.uploading[key];
        return ok;
    },

    // behöver nån mekanism för att ladda upp alla objekt som väntar på uppladdning
    // -- med visuell feedback till deltagaren, så att han/hon kan vänta tills det är klart.

    // Retries every log entry still waiting, whoever is logged in: each entry carries its
    // own name and hash.
    async upload_all_log_entries() {
        if (this.sweeping || !navigator.onLine) {
            return;
        }
        this.sweeping = true;
        try {
            const keys = log_entry_keys();
            for (var i = 0; i < keys.length; i++) {
                const entry = read_log_entry(keys[i]);
                if (entry) {
                    await this.attempt_to_upload(keys[i], entry.id, entry.data);
                }
            }
        }
        finally {
            this.sweeping = false;
        }
    },

    // Sends an error to the server's /client_error, which keeps it apart from `log` (the
    // analysis scripts read `log`). Called from the error handlers, so it never throws, and
    // it sends each error once, at most MAX_ERROR_REPORTS per page load and nothing while
    // offline: an error that repeats, or one in the reporting itself, can't flood the server
    // or loop.
    report_error(kind, err, info) {
        try {
            const message = String(err);
            if (this.reported[kind + message] || this.num_reported >= MAX_ERROR_REPORTS || !navigator.onLine) {
                return;
            }
            this.reported[kind + message] = true;
            this.num_reported += 1;
            const state = this.vue ? this.vue.$store.state : {};
            superagent.post(this.SERVER + '/client_error')
                .timeout(TIMEOUT)
                .send({
                    name: state.loginName,
                    study: state.study,
                    mod: state.module,
                    time_session: state.session,
                    time_event: Date.now(),
                    kind: kind,
                    message: message,
                    stack: err && err.stack,
                    info: info
                })
                .then(() => {}, () => {});
        }
        catch (e) {
            // nothing more to do
        }
    },

    async history(topic, mod = this.vue.$store.state.module) {
        const id = {
            name: this.vue.$store.state.loginName,
            hash: this.vue.$store.state.loginHash,
            mod: mod,
            topic: topic
        };
        const key = this.vue.$store.state.loginName + '_history_' + mod + '_' + topic;

        if (navigator.onLine) {
            return await superagent.post(this.SERVER + '/download')
                .timeout(TIMEOUT)
                .send({ id: id })
                .then(res => {
                    const data = JSON.parse(res.text);
                    const success = data.success;
                    if (success) {
                        store_locally(key, JSON.stringify(data.result));
                        return data.result;
                    }
                    else {
                        //console.error('persist -- failed to download: ');
                        return JSON.parse(localStorage.getItem(key)) || [];
                    }
                }).catch((/*err*/) => {
                    //console.error(err);
                    return JSON.parse(localStorage.getItem(key)) || [];
                });
        }
        else {
            return JSON.parse(localStorage.getItem(key)) || [];
        }
    },


    async addToHistory(topic, value) {
        var h = await this.history(topic);
        h.push(value);
        await this.log(topic, value);
        return h;
    }
}


// Local storage can be full, which is likelier now that unconfirmed log entries are kept, and
// old Safari private windows refuse every write. A failed write must not stop what comes next:
// a login, or the upload in log().
function store_locally(key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch (e) {
        // nothing stored
    }
}

// log() keeps each entry in local storage as `<name>_log_<random>` = {id, data} until the
// server confirms it. Returns the entry, or null if `key` is not one.
function read_log_entry(key) {
    if (key === null || key.indexOf('_log_') < 0) {
        return null;
    }
    try {
        const entry = JSON.parse(localStorage.getItem(key));
        return entry && entry.id && entry.id.topic !== undefined ? entry : null;
    }
    catch (e) {
        return null;
    }
}

function all_keys() {
    const keys = [];
    for (var i = 0; i < localStorage.length; i++) {
        keys.push(localStorage.key(i));
    }
    return keys;
}

// A copy of the list, since uploads remove entries while it is walked.
function log_entry_keys() {
    return all_keys().filter(key => read_log_entry(key) !== null);
}

function clear_all_but_log_entries() {
    all_keys().forEach(key => {
        if (read_log_entry(key) === null) {
            localStorage.removeItem(key);
        }
    });
}

async function computeHash(name, password) { //, token = '') {
    return name.substring(0, 1) + password.substring(0, 1);
    /*const salt = "psymet.app";
    const str = salt.concat(name).concat(password);
    //const str = name.concat(concat(password, token), salt);
    const arr = new TextEncoder().encode(str);
    return await crypto.subtle.digest("SHA-256", arr).then(buf => {
        var view = new Uint32Array(buf);
        var hash = '';
        for (var i in view) {
            hash = hash.concat(view[i].toString(36));
        }
        return hash;
    });*/
}
